<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="secondary" dark class="title" flat>
        <v-toolbar-title>
            <v-icon left>fas fa-boxes</v-icon>
            {{ resource.id == undefined ? "Adding New Resource" : `Editing: ${resource.title}`}}
        </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon color="white" @click="$emit('close')">
          <v-icon>fas fa-times-circle</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="6">
            <v-text-field
                v-model="resource.title"
                label="Title"
                filled
                color="secondary"
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
            <v-text-field
                v-model="resource.author"
                label="Author"
                filled
                color="secondary"
            ></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-text-field
                v-model="resource.link"
                label="Link"
                filled
                color="secondary"
            ></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-textarea
                v-model="resource.description"
                label="Book Description"
                filled
                color="secondary"
            ></v-textarea>
        </v-col>
        <v-col cols="12" class="title">
            Formats:
        </v-col>
        <v-col cols="12">
            <v-divider></v-divider>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.audio.owned"
                label="Audio File"
                color="secondary"
            ></v-checkbox>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.book.owned"
                label="Book"
                color="secondary"
            ></v-checkbox>
            <v-text-field
                v-model="resource.format.book.count"
                label="Total Books:"
                color="secondary"
                filled
                v-show="resource.format.book.owned"
            ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.dvd.owned"
                label="DVD"
                color="secondary"
            ></v-checkbox>
            <v-text-field
                v-model="resource.format.dvd.count"
                label="Total DVDs:"
                color="secondary"
                filled
                v-show="resource.format.dvd.owned"
            ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.leaderGuide.owned"
                label="Leader Guide"
                color="secondary"
            ></v-checkbox>
            <v-text-field
                v-model="resource.format.leaderGuide.count"
                label="Total Leader Guides:"
                color="secondary"
                filled
                v-show="resource.format.leaderGuide.owned"
            ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.onlineVideo.owned"
                label="Online Video"
                color="secondary"
            ></v-checkbox>
        </v-col>
        <v-col cols="6" md="2">
            <v-checkbox
                v-model="resource.format.workbook.owned"
                label="Workbook"
                color="secondary"
            ></v-checkbox>
            <v-text-field
                v-model="resource.format.workbook.count"
                label="Total Workbooks:"
                color="secondary"
                filled
                v-show="resource.format.workbook.owned"
            ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="pt-3">
        <v-col cols="12" class="text-right">
            <v-btn color="accent" outlined :disabled="!checkData" @click="save()">
                <v-icon left>fas fa-save</v-icon>
                {{resource.id == undefined ? 'Save New' : 'Update'}} Resource
            </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
      selectedResource: Object
  },
  data(){
    return {
        data            : "",
        resource        : this.selectedResource,
        searchString    : ""
    }
  },
  methods: {
      save(){
          if (this.resource.id == undefined){
              this.$store.dispatch('addResource', this.resource)
          }
          else {
              this.$store.dispatch('updateResource', this.resource)
          }
      }
  },
  computed: {
      checkData(){
          if (this.resource.title == undefined || this.resource.title == '' || this.resource.description == undefined || this.resource.description == '' || this.resource.author == undefined || this.resource.author == ''){
              return false
          }
          else {
              return true
          }
      }
  }
}
</script>
